/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiTabChartPayloadFromJSON, ApiTabChartPayloadToJSON, } from './ApiTabChartPayload';
import { ApiTabElementTypeFromJSON, ApiTabElementTypeToJSON, } from './ApiTabElementType';
export function ApiTabElementPayloadFromJSON(json) {
    return ApiTabElementPayloadFromJSONTyped(json, false);
}
export function ApiTabElementPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chart': !exists(json, 'chart') ? undefined : ApiTabChartPayloadFromJSON(json['chart']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : ApiTabElementTypeFromJSON(json['type']),
    };
}
export function ApiTabElementPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chart': ApiTabChartPayloadToJSON(value.chart),
        'description': value.description,
        'name': value.name,
        'type': ApiTabElementTypeToJSON(value.type),
    };
}
